import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-ticket',
  templateUrl: './submit-ticket.component.html',
  styleUrls: ['./submit-ticket.component.css']
})
export class SubmitTicketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
